// @flow

import IntlStore from "shared/stores/IntlStore"

export const BOOKING_CHANNELS = [
  { value: "FROGNE", label: "Frogne" },
  { value: "WEB", label: "Web Booking" },
  { value: "TAXISYSTEM", label: "Taxi System" },
  { value: "LEGACY_BC,BC_API", label: "Booking Client" },
  { value: "SUTI", label: "Suti Orders" },
  { value: "LEGACY", label: "Legacy Orders" },
  { value: "LEGACY_APP,MOBILE_APP,IOS,ANDROID", label: "Mobile App" },
  { value: "VOICEBOT_API", label: "Voicebot" }
]

export const ORDER_STATES = [
  {
    value: "PENDING",
    label: (IntlStore.formatMessage("apps.order-search.state.pending"): any)
  },
  {
    value: "EN_ROUTE",
    label: (IntlStore.formatMessage("apps.order-search.state.enroute"): any)
  },
  {
    value: "IN_VEHICLE",
    label: (IntlStore.formatMessage("apps.order-search.state.invehicle"): any)
  },
  {
    value: "DROPPED_OFF",
    label: (IntlStore.formatMessage("apps.order-search.state.droppedoff"): any)
  },
  {
    value: "COMPLETED",
    label: (IntlStore.formatMessage("apps.order-search.state.completed"): any)
  },
  {
    value: "CANCELLED",
    label: (IntlStore.formatMessage("apps.order-search.state.cancelled"): any)
  },
  {
    value: "CANCELLED_AT_DOOR",
    label: (IntlStore.formatMessage(
      "apps.order-search.state.cancelledatdoor"
    ): any)
  },
  {
    value: "NO_SHOW",
    label: (IntlStore.formatMessage("apps.order-search.state.noshow"): any)
  },
  {
    value: "INVALID_NO_SHOW",
    label: (IntlStore.formatMessage(
      "apps.order-search.state.invalidnoshow"
    ): any)
  },
  {
    value: "UNKNOWN",
    label: (IntlStore.formatMessage("apps.order-search.state.unknown"): any)
  },
  {
    value: "FAILED",
    label: (IntlStore.formatMessage("apps.order-search.state.failed"): any)
  },
  {
    value: "EXTERNAL",
    label: (IntlStore.formatMessage("apps.order-search.state.external"): any)
  }
]
